export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const EXTENSION_LIST_SUCCESS = 'EXTENSION_LIST_SUCCESS';
export const EXTENSION_TABLE_DATA_SUCCESS = 'EXTENSION_TABLE_DATA_SUCCESS';
